<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-25">
      <md-field>
        <label>{{ $t("common.subject") }}</label>
        <md-input v-model="content.subject" :disabled="isReadOnly"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-100">
      <label class="text-title">{{ $t("survey.body") }}</label>
      <Editor
        v-model="content.body"
        :init="editorInit"
        :disabled="isReadOnly"
      />
    </div>
    <div class="md-layout-item md-size-100 md-layout my-4">
      <div class="md-layout-item md-size-30 pl-0 font-semibold">
        {{ name }} = {{ $t("survey.respondent_full_name") }}
      </div>
      <div class="md-layout-item md-size-30 font-semibold">
        {{ url }} = {{ $t("survey.user_survey_link") }}
      </div>
      <div class="md-layout-item md-size-100 flex justify-center gap-4 mt-5">
        <md-button
          class="md-primary h-[40px] text-3xl"
          @click="backToStructure"
        >
          &lt;
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
import Editor from "@tinymce/tinymce-vue";

export default {
  props: ["data", "isReadOnly"],
  components: { Editor },
  data() {
    return {
      EDITOR_API_KEY: process.env.VUE_APP_TINY_API_KEY,
      name: "${full_name}",
      url: "${survey_url}",
      content: {
        subject: "",
        body:
          "<p>Hello ${full_name}</p>" +
          "<p>We value your input! Please take a few minutes share your feedback on your recent experience by completing the survey below.</p>" +
          "<p>Please note that your survey link is unique to your invitation and should not be shared or forwarded.</p>" +
          "<p>Click below link to take the survey.</p>" +
          "<p>${survey_url}</p>"
      },
      editorInit: {
        height: 500,
        menubar: "file edit view",
        toolbar:
          "undo redo | bold italic | alignleft aligncenter alignright alignjustify"
      }
    };
  },
  created() {
    if (this.data) {
      this.content = this.data;
    }
  },
  methods: {
    backToStructure() {
      this.$emit("backToStructure", this.content);
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
      this.$emit("save");
    },
    saveAndSend() {
      this.$emit("saveAndSend");
    }
  }
};
</script>
<style lang="scss" scoped>
.md-field .md-textarea[disabled] {
  cursor: not-allowed;
}
</style>
